import { vuex as GenerateReport } from "../views/GenerateReport";
import { vuex as Dashboard } from "../views/FullDashboard";
import { vuex as ReportDetails } from "../views/ReportDetails";
import { vuex as ActiveDistricts } from "../views/ActiveDistricts";
// create a new object and preserv original keys
export default { ...GenerateReport.modules, ...Dashboard.modules, ...ReportDetails.modules, ...ActiveDistricts.modules };
